import { Checkbox } from '~/components/granular';
import { classNames } from '~/utils/styles';
import { useDropdownContext } from '../../Dropdown';

export function DropdownSelectAll() {
  const { selectAllLabel, areAllItemsSelected, handleToggleSelectAll } = useDropdownContext();

  const selectAllContainerClasses = classNames(
    'w-full px-4 py-2 text-base text-neutral-1000',
    'hover:cursor-pointer hover:bg-neutral-200 focus-visible:outline-hidden',
  );

  return (
    // oxlint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO: move handlers
    <div className={selectAllContainerClasses} onClick={handleToggleSelectAll} onKeyUp={handleToggleSelectAll}>
      <Checkbox checked={areAllItemsSelected()} label={selectAllLabel} />
    </div>
  );
}
